import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { Box } from '@mui/material';

import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { ConfigureModuleCard } from 'app/pages/ConfigurePage/components/ConfigureModuleCard';

import { useMonitorPage } from '../hooks/useMonitorPage';
import {
  MONITOR_RESOURCE_NURTURING_CANDIDATE_AUDIT,
  MONITOR_RESOURCE_NURTURING_PLAN_EXECUTION,
} from '../utils/monitorResourceIds';

const NurturingCandidateAuditCardInner = () => {
  const { goToNurturingCandidateAudit } = useMonitorPage();

  return (
    <ConfigureModuleCard
      title="Nurturing Candidate Audit"
      description="Audit nurturing candidate picker execution logs"
      icon={<FactCheckIcon fontSize="small" />}
      onOpen={goToNurturingCandidateAudit}
    />
  );
};

const NurturingPlanExecutionCardInner = () => {
  const { goToNurturingPlanExecution, hasLaunchDate, hasSelectedDealer } = useMonitorPage();
  const isExecutionAvailable = hasSelectedDealer && hasLaunchDate;

  return (
    <ConfigureModuleCard
      title="Nurturing Plan Execution"
      description={
        isExecutionAvailable
          ? 'Monitor and manage nurturing plan execution runs'
          : 'Launch the dealer first to monitor nurturing plan execution'
      }
      icon={<DirectionsRunIcon fontSize="small" />}
      onOpen={goToNurturingPlanExecution}
      openDisabled={!isExecutionAvailable}
    />
  );
};

const ProtectedNurturingCandidateAuditCard = withResourceProtection(
  NurturingCandidateAuditCardInner,
  MONITOR_RESOURCE_NURTURING_CANDIDATE_AUDIT,
  null,
);

const ProtectedNurturingPlanExecutionCard = withResourceProtection(
  NurturingPlanExecutionCardInner,
  MONITOR_RESOURCE_NURTURING_PLAN_EXECUTION,
  null,
);

export const MonitorModules = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
        },
        gap: 3,
        width: '100%',
        maxWidth: 1200,
        mx: 'auto',
        alignContent: 'start',
      }}
    >
      <ProtectedNurturingCandidateAuditCard />
      <ProtectedNurturingPlanExecutionCard />
    </Box>
  );
};
